module.exports = __webpack_public_path__ + "media/new_images/app-store-766b9a4c.svg";